__turbopack_context__.v({
  "actions": "SearchNoResults-module-scss-module__kiTSNG__actions",
  "container": "SearchNoResults-module-scss-module__kiTSNG__container",
  "content": "SearchNoResults-module-scss-module__kiTSNG__content",
  "message": "SearchNoResults-module-scss-module__kiTSNG__message",
  "primaryAction": "SearchNoResults-module-scss-module__kiTSNG__primaryAction",
  "query": "SearchNoResults-module-scss-module__kiTSNG__query",
  "secondaryAction": "SearchNoResults-module-scss-module__kiTSNG__secondaryAction",
  "title": "SearchNoResults-module-scss-module__kiTSNG__title",
});
